//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import { LoadingStateWrapper } from "../components/data-display/LoadingState";
import { CLIENT_PAGES } from "../stores/client-types";
import { IRootStore } from "../stores/index";
import SubjectsPage from "./subjects";
import PEditPage from "./personal-info";
import LEditPage from "./location-info";
import VerificationPage from "./verification/id-verification";
import GuarantorPage from "./verification/guarantors";
import UploadProofPage from "./verification/upload-proof";
import EducationHistory from "./education";
import WorkHistory from "./work";
import SpecialNeeds from "./specialNeeds";
import ProfilePhoto from "./profilePhoto";
import Schedule from "./schedule";
import JobsPage from "./jobs";
import React from "react";
import PaymentInformation from "./payment-info";
import { STEPS } from "../stores/utils";
// import PostApplicationComponentOne from "../tutor-revamp/PostApplicationComponentOne";
// import PostApplicationComponentTwo from "../tutor-revamp/PostApplicationComponentTwo";

type Props = {
  initialData: any;
  page: string;
  store: IRootStore;
  saveTutorInfo: (data: any) => Promise<any>;
  isLiteTutor?: boolean;
  liteLocation?: any;
  generateProfileSummary: (data: any) => Promise<any>;
  generateDescription?: (data: any) => Promise<any>;
  [key: string]: any;
};

function Root({
  initialData,
  page,
  store,
  saveTutorInfo,
  isLiteTutor,
  liteLocation,
  generateProfileSummary,
  generateDescription,
  ...rest
}: Props) {
  async function initialize(setLoading) {
    store.initializeClientTutorData(page, initialData);
    setLoading(false);
  }

  const getLoadingText = () => {
    if (page === CLIENT_PAGES.SUBJECTS) {
      return "Loading subject details...";
    }
  };

  return (
    <LoadingStateWrapper initialize={initialize} text={getLoadingText()}>
      {page === CLIENT_PAGES.SUBJECTS ? (
        <SubjectsPage
          displayPrompt={false}
          store={store}
          generateDescription={generateDescription}
          isLiteTutor={isLiteTutor}
        />
      ) : null}
      {page === CLIENT_PAGES.PERSONAL_INFO ? (
        <PEditPage {...{ store, saveTutorInfo }} isLiteTutor={isLiteTutor} />
      ) : null}
      {page === CLIENT_PAGES.LOCATION_INFO ? (
        <LEditPage
          {...{ store, saveTutorInfo }}
          isLiteTutor={isLiteTutor}
          liteLocation={liteLocation}
        />
      ) : null}
      {page === CLIENT_PAGES.VERIFICATION ? (
        <VerificationPage
          store={store}
          onSubmit={() => {}}
          afterUpload={() => store.onFormSubmit({}, STEPS.VERIFICATION, "")}
        />
      ) : null}
      {page === CLIENT_PAGES.GUARANTOR_INFO ? (
        <GuarantorPage store={store} />
      ) : null}
      {page === CLIENT_PAGES.UPLOAD_PROOF ? (
        <UploadProofPage store={store} />
      ) : null}
      {page === CLIENT_PAGES.CREDENTIALS ? (
        <EducationHistory {...{ store, saveTutorInfo }} />
      ) : null}
      {page === CLIENT_PAGES.WORK_HISTORY ? (
        <WorkHistory store={store} />
      ) : null}
      {page === CLIENT_PAGES.TEACHING_PROFILE ? (
        <SpecialNeeds
          tutor_profile={initialData.tutorInfo}
          saveTutorInfo={saveTutorInfo}
          generateProfileSummary={generateProfileSummary}
          isLiteTutor={isLiteTutor}
        />
      ) : null}
      {page === CLIENT_PAGES.PROFILE_PHOTO ? (
        <ProfilePhoto
          store={store}
          afterUpload={() => store.onFormSubmit({}, STEPS.VERIFICATION, "")}
        />
      ) : null}
      {page === CLIENT_PAGES.SCHEDULE_INFO ? <Schedule store={store} /> : null}
      {page === CLIENT_PAGES.JOBS ? <JobsPage store={store} {...rest} /> : null}
      {page === CLIENT_PAGES.PAYMENT_INFO ? (
        <PaymentInformation store={store} {...rest} />
      ) : null}
      {/* {page === CLIENT_PAGES.POST_APPLICATION_1 ? (
        <PostApplicationComponentOne store={store} {...rest} />
      ) : null}
      {page === CLIENT_PAGES.POST_APPLICATION_2 ? (
        <PostApplicationComponentTwo store={store} {...rest} />
      ) : null} */}
    </LoadingStateWrapper>
  );
}

export default observer(Root);
